import { useDashboardViewModel } from "../viewmodel/useDashboardViewModel";
import { DashboardCard } from "./DashboardCard";
import { LoadingSpinner } from "@/shared/components";

/**
 * DashboardPage Component
 * Page-level component that uses ViewModel
 */
export const DashboardPage = () => {
  const { data, isLoading, error } = useDashboardViewModel();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <div>Error: {error.message}</div>;
  if (!data) return <div>No data</div>;

  return (
    <div>
      <h1>Dashboard</h1>
      <DashboardCard title="Total Users" value={data.stats.totalUsers} />
      <DashboardCard title="Active Users" value={data.stats.activeUsers} />
      <DashboardCard title="Revenue" value={`$${data.stats.revenue}`} />
    </div>
  );
};
